class NotificationMessageQueue 
{
  constructor() {
    
    this.messages = [];
    this.cookieName = "bego-message-queue";

    this.init();
  }

  init() {
    var match = document.cookie.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'));
    if (match) {
        this.messages = JSON.parse(match[2]);
    }
  }
  
  add(message) {
    var date = new Date();
    date.setTime(date.getTime()+(1*24*60*60*1000));
    this.messages.push({"message": message});
    document.cookie = this.cookieName + "=" + JSON.stringify(this.messages) + "; expires=" + date.toGMTString() + ";path=/";
  }
  
  clearForcedMessages() {
    document.querySelector('[data-messages]').innerHTML = "";
  }
  
  forceDisplay(message) {
    document.querySelector('[data-messages]').insertAdjacentHTML('beforeend', '<p>'+message+'</p>');
  }
  
  getMessages() {
    return this.messages;
  }
    
  clear() {
    document.cookie = this.cookieName + "=" + JSON.stringify(this.messages) + "; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
  }
}